import { useState, useEffect } from 'react';

// Приводит что угодно (+7..., 8..., 7..., голые цифры) к 10 цифрам после кода страны
function digitsOnly(raw: string): string {
  let d = raw.replace(/\D/g, '');
  if (d.startsWith('8') || d.startsWith('7')) d = d.slice(1);
  return d.slice(0, 10);
}

function formatMasked(digits: string): string {
  const p1 = digits.slice(0, 3);
  const p2 = digits.slice(3, 6);
  const p3 = digits.slice(6, 8);
  const p4 = digits.slice(8, 10);
  let result = '8';
  if (digits.length > 0) result += ` (${p1}`;
  if (digits.length >= 3) result += ')';
  if (digits.length > 3) result += ` ${p2}`;
  if (digits.length > 6) result += `-${p3}`;
  if (digits.length > 8) result += `-${p4}`;
  return result;
}

interface PhoneInputProps {
  // Значение в формате "+7XXXXXXXXXX" (как хранится на бэкенде)
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export default function PhoneInput({ value, onChange, placeholder }: PhoneInputProps) {
  const [digits, setDigits] = useState(() => digitsOnly(value));

  useEffect(() => {
    setDigits(digitsOnly(value));
  }, [value]);

  // Пока номер не набран полностью (10 цифр), наружу уходит '' — на глаз поле выглядит
  // заполненным (видны введённые цифры), но реально сохранится пустой телефон. Подсвечиваем
  // это состояние, чтобы диспетчер не стёр телефон случайно, не заметив
  const incomplete = digits.length > 0 && digits.length < 10;

  return (
    <input
      type="tel"
      className={incomplete ? 'phone-input-incomplete' : undefined}
      title={incomplete ? 'Номер введён не полностью — не сохранится' : undefined}
      value={digits.length > 0 ? formatMasked(digits) : ''}
      placeholder={placeholder ?? '8 (___) ___-__-__'}
      onChange={(e) => {
        const next = digitsOnly(e.target.value);
        setDigits(next);
        onChange(next.length === 10 ? `+7${next}` : '');
      }}
    />
  );
}
